// extracted by mini-css-extract-plugin
export default {"form":"NovaVersao_form__JF0hK","areaBtn":"NovaVersao_areaBtn__HH2Bn","btn":"NovaVersao_btn__uk2rd","btn2":"NovaVersao_btn2__FHB29"};